import { Component, ViewChild, TemplateRef, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { qmsService } from '../../qms.service';
import { PaginationService } from 'src/app/PaginationService';
import { AuService } from '../au.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { EditorComponent } from 'src/app/editor/editor.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

export interface PopupData {
  title: string;
}
@Component({
  selector: 'app-au-questions',
  templateUrl: './au-questions.component.html',
  styleUrls: ['./au-questions.component.scss']
})

export class AuQuestionsComponent implements OnChanges, OnInit {

  @Input() updateQuestionarie: any;
  isProcessing: boolean;
  dateCustomClasses: DatepickerDateCustomClasses[];
  auQuestionsData: any = {};
  @ViewChild('flexifieldValueSelected1') flexifieldValueSelected1: MatSelect;
  displayQuestionAndAnswerContainer: any = false;
  markFieldValuesAsMandatory: any = false;
  sessionUserId: any;
  auNo: number;
  columnCount: number = 0;
  freezeAuditeeColumn: boolean = false;
  freezeAuditorColumn: boolean = false;
  showAuditeeColumn: boolean = false;
  showAuditorColumn: boolean = false;

  organizedQuesAndAnswTxt: any;
  flexifieldValueTxt: any;
  reviewStatusTxt: any;
  commonReviewStatusTxt: any;
  fieldTypeTxt: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  departmentSearchText: string = '';
  constructor(
    public dialog: MatDialog,
    public paginationService: PaginationService,
    public router: Router,
    public message: messageService,
    public qualityService: qmsService,
    public auService: AuService,

    private readonly snackBar: MatSnackBar,
    public readonly appService: AppService,
    private readonly elem: ElementRef,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];


    this.auNo = this.qualityService.activityId;
  };

  focusSearch(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };

  public objectComparisonFunction = function (option: any, value: any): boolean {
    return option.valueExp == value.valueExp;
  };
  flexifieldValueSelected = false;
  toggleAllSelection(value: any, questionItem?: any) {
    if (value == 'flexifieldValueSelected' && questionItem) {
      if (this.isAllOptionsSelected(questionItem)) {
        // Deselect all
        questionItem.selectedFlexifieldValue = [];
      } else {
        // Select all
        questionItem.selectedFlexifieldValue = questionItem.organizedQuesAndAnswData.map((item: any) => item.valueExp);
      }
    }
    if (value == 'pdf') {
      if (this.pdfColumnSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.convertArrayToString(this.selectedColumns);
        this.handleDropDownValidation('execl-pdf', this.selectedColumns);
      });
    }
  }

  ngOnChanges(changes: any): void {
    this.updateQuestionsAppearance();
  }

  updateQuestionsAppearance() {
    if (this.auService.tabName == "Conduct Audit") {
      this.hideActionBtn = true;
    } else if (this.qualityService.activity.status == 'Pending Plan Approval') {
      this.hideActionBtn = true;
    } else if (this.qualityService.activity.status == 'Planned') {
      this.hideActionBtn = true;
    } else if (this.qualityService.activity.status == 'Initiated') {
      this.hideActionBtn = true;
    } else if (this.qualityService.activity.status == "Draft(Plan)" || this.qualityService.activity.status == "Plan Created"
      || this.qualityService.activity.status == "Plan Rejected" || this.qualityService.activity.status == "Re-Draft(Plan)") {
      this.hideActionBtn = false;
    } else {
      this.hideActionBtn = true;
    }

    if (this.auService.isAuditee && (this.qualityService.activity.status == 'Initiated' || this.qualityService.activity.status == 'In Progress/Q&A Pending')) {
      this.columnCount = 2;
      this.showAuditeeColumn = true;
      this.showAuditorColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = false;
    } else if ((this.auService.isAuditor || this.auService.isAuditee) && (this.qualityService.activity.status == 'Initiated/Received Q&A Response' || this.qualityService.activity.status == 'Received Q&A Response' || this.qualityService.activity.status == 'In Progress/Received Q&A Response')) {
      if (this.auService.isAuditor) {
        this.columnCount = 4;
        this.showAuditeeColumn = this.showAuditorColumn = this.freezeAuditeeColumn = true;
        this.freezeAuditorColumn = false;
      } else if (this.auService.isAuditee) {
        this.columnCount = 4;
        this.showAuditeeColumn = this.freezeAuditeeColumn = true;
        this.freezeAuditorColumn = true;
        this.showAuditorColumn = true;
      }
    } else if ((this.auService.isAuditor || this.auService.isAuditee) && (this.qualityService.activity.status == 'Initiated/Auditor Requested More Info. On Q&A Responses' || this.qualityService.activity.status == 'Auditor Requested More Info. On Q&A Responses' || this.qualityService.activity.status == 'In Progress/Auditor Requested More Info. On Q&A Responses')) {
      if (this.auService.isAuditor) {
        this.columnCount = 4;
        this.showAuditeeColumn = this.showAuditorColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = true;
      } else if (this.auService.isAuditee) {
        this.columnCount = 4;
        this.showAuditeeColumn = this.showAuditorColumn = true;
        this.freezeAuditeeColumn = false;
        this.freezeAuditorColumn = true;
      }
    } else if ((this.auService.isAuditor || this.auService.isAuditee) && (this.qualityService.activity.status == 'Pending Peer Review')) {
      if (this.auService.isAuditor) {
        this.columnCount = 4;
        this.showAuditeeColumn = this.showAuditorColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = true;
      } else if (this.auService.isAuditee) {
        this.columnCount = 0;
        this.showAuditorColumn = this.showAuditeeColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = true;
      }
    } else if (this.qualityService.activity.status.includes('In Progress') || this.qualityService.activity.status.includes('Closure Review') || this.qualityService.activity.status.includes('Closure Approve') || this.qualityService.activity.status.includes('Close')) {
      this.columnCount = 4;
      this.showAuditeeColumn = this.showAuditorColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = true;
    } else {
      this.columnCount = 0;
      this.showAuditorColumn = this.showAuditeeColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = false;
    }
  }

  getColumnSizes() {
    if (this.columnCount == 0) {
      return '0.4fr 0.3fr 2fr 0.3fr';
    } else {
      return '0.2fr 0.2fr 1fr repeat(' + this.columnCount + ', 1fr) 0.8fr';
    }
  }

  selectedFieldType: any = null;
  selectedReviewStatus: any = null;

  dropDownForFieldType: any[];
  dropDownForReviewStatus: any[];

  fieldTypeDropDown: any = [];
  reviewStatusDropDown: any[];
  getQmsTaskDocumentsVwDetails: any = [];
  reviewStatusDropDownBulkStatus: any = [];
  participantData: any = [];
  ngOnInit() {
    this.auNo = this.qualityService.activityId;
    this.isProcessing = true;
    this.auService.questionnaireList = [];
    this.displayQuestionAndAnswerContainer = false;
    this.appService.getCodeListsByGroup("FIELD_TYPE").subscribe((data: any) => {
      this.dropDownForFieldType = data;
      this.selectBoxForFieldType();
      this.isProcessing = false;
    })

    this.appService.getCodeListsByGroup('AU_REVIEW_STATUS').subscribe((data: any) => {
      this.dropDownForReviewStatus = data;
      this.isProcessing = false;
      if (this.qualityService.activityId) this.displayQuestionsFunction();
    })

    this.appService.getAuParticipantsByAuNo(this.qualityService.activityId).subscribe((participantResponse: any) => {
      const foundPrimaryContactData = participantResponse.find((item: any) => item.isPrimaryContact == 'Y');
      this.isProcessing = false;
      if (foundPrimaryContactData) {
        this.participantData = foundPrimaryContactData;
        if (this.participantData.applicationUserId == this.message.getUserId()) {
          this.auService.isAuditee = true;
        } else {
          this.auService.isAuditee = false;
        }
      }
    })
  }

  getUploadColors() {
    if (this.auService.questionnaireList[this.documentIdx]) {
      this.appService.getQmsTaskDocumentsVwDetailsByauRefId(this.qualityService.activityId, this.auService.questionnaireList[this.documentIdx].questionId).subscribe((response: any) => {
        if (response.length > 0) {
          if (this.auService.questionnaireList[this.documentIdx].questionId == response[0].auditRefId) {
            this.auService.questionnaireList[this.documentIdx].docs = response;
          }
        }
      });
    }

    this.appService.getQmsTaskDocumentsVwDetailsByModule(this.qualityService.moduleName, this.qualityService.activityId).subscribe((response: any) => {
      this.getQmsTaskDocumentsVwDetails = response;
      for (const question of this.auService.questionnaireList) {
        question.isDocumentUploaded = false;

        for (const element of this.getQmsTaskDocumentsVwDetails) {
          if (question.questionId == element.auditRefId) {
            question.isDocumentUploaded = true;
            break;
          }
        }
      }
    })
  }

  refreshQuestions() {
    this.ngOnInit();
  }

  selectBoxForFieldType() {
    this.fieldTypeDropDown = this.dropDownForFieldType.map((item: any) => {
      return {
        valueExp: item.codelistCode,
        displayExp: item.codelistName,
      };
    });
    this.fieldTypeDropDown = this.fieldTypeDropDown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Heading'));
  }

  onFieldTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        setTimeout(() => {
          this.markFieldValuesAsMandatory = ['Multiselect Drop Down', 'Drop Down', 'Radio Button', 'Check Box'].includes(item.valueExp);
          this.handleDropDownValidation('field-type-validation', this.selectedFieldType);
        })

      } else {
        setTimeout(() => {
          this.markFieldValuesAsMandatory = false;
          this.handleDropDownValidation('field-type-validation', this.selectedFieldType);
        })
      }
    };
  }

  onFieldTypeDeSelect() {
    this.markFieldValuesAsMandatory = false;
    this.handleDropDownValidation('field-type-validation', this.selectedFieldType);
  }

  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addPopup', { static: true }) addPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('selectQuestionPopup', { static: true }) selectQuestionPopup: TemplateRef<any>;
  @ViewChild('uploadDocuments', { static: true }) uploadDocuments: TemplateRef<any>;

  visibleAddPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleSelectQuestionPopup: MatDialogRef<TemplateRef<any>>;
  visibleUploadDocumentsPopup: MatDialogRef<TemplateRef<any>>;

  addPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  selectQuestionPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  uploadPopupConfig = {
    width: '80%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
  };

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  };


  operationFlag: any;

  openAddPopup() {
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Add Question";
    this.auQuestionsData = {};
    this.auQuestionsData.addQuestionType = '';
    this.selectedFieldType = null;
    this.markFieldValuesAsMandatory = false;
    this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
  }

  onOptionChanged(event: any) {
    if (event.value == 'fromTemplate') this.getCall();
  }

  cancelAddFunction() {
    this.visibleAddPopup.close();
  }

  handleDropDownValidation(fieldId: string, selectedItems: any) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = selectedItems == null && field ? 'red' : '';
  }

  onNgModuleChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '' : 'red';
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  addFunction(auQuestionsData: any) {
    if (auQuestionsData.addQuestionType == 'manually') {

      const validFieldTypes = ['Check Box', 'Radio Button', 'Drop Down', 'Multiselect Drop Down'];

      const validations = [
        { condition: !auQuestionsData.question, id: 'question-validation' },
        { condition: this.selectedFieldType == null, id: 'field-type-validation' },
        {
          condition: !auQuestionsData.fieldValues && this.selectedFieldType != null && validFieldTypes.includes(this.selectedFieldType),
          id: 'field-value-validation'
        },
      ]

      const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

      if (invalidIds.length > 0) {
        this.fieldValidation(invalidIds);
      } else {
        const obj = {
          auNo: this.auNo,
          question: auQuestionsData.question,
          fieldTypeCode: this.selectedFieldType,
          fieldValues: auQuestionsData.fieldValues
        }

        if (this.operationFlag == 'ADD') {
          this.createQuestion(obj);
        } else {
          this.updateQuestion(obj, auQuestionsData);
        }
      }
    }
  }

  createQuestion(obj: any) {
    this.isProcessing = true;

    this.appService.createQmsAuQuestion(obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.visibleAddPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
          this.displayQuestionsFunction();
        } else {
          this.showSnackBar(Response.result, Response.resultType);
        }
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  updateQuestion(obj: any, question: any) {
    this.isProcessing = true;

    const update_obj = {
      ...obj, questionId: question.questionId, questionSeq: question.questionSeq,
      ...question.templateId && { templateId: question.templateId },
      ...question.templateQuestionId && { templateQuestionId: question.templateQuestionId },
    }

    this.appService.updateQmsAuQuestion(update_obj).subscribe({
      next: (Response: any) => {
        if (Response.resultType == "S") {
          this.visibleAddPopup.close();
          this.showSnackBar(Response.result, Response.resultType);
          this.displayQuestionsFunction();
        } else {
          this.showSnackBar(Response.result, Response.resultType);
        }
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  selectedQuesAndAnswDropDown: any = [];

  onQuesAndAnswSelect(event: any, item: any, questionItem?: any) {
    if (event.isUserInput && questionItem) {
      // Update Select All state when individual options are changed
      setTimeout(() => {
        const totalOptions = questionItem.fieldValues.split(',').length;
        questionItem.isSelectAllChecked = questionItem.selectedFlexifieldValue?.length === totalOptions;
      });
    }
  }

  onQuesAndAnswRemoved(item: any) { };
  title: any;
  contentList: any;
  visibleReorderContentPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('reorderContentPopup', { static: true }) reorderContentPopup: TemplateRef<any>;
  reorderContentPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.contentList, event.previousIndex, event.currentIndex);
    for (let i = 0; i < this.contentList.length; i++) {
      this.contentList[i].newSeq = i + 1;
    }
  }

  callReorderFunc() {
    this.title = "Reorder Questions";

    this.isProcessing = true;
    this.appService.getQmsAuQuestionsByAuNO(this.auNo).subscribe((data: any) => {

      if (data.length > 0) {
        this.displayQuestionAndAnswerContainer = true;
        data.forEach((item: any) => {
          item.splittedQuesAndAnswData = [];
          item.organizedQuesAndAnswData = [];
          item.reviewStatusDropDown = [];

          if (item.fieldTypeCode === 'Drop Down' || item.fieldTypeCode === 'Multiselect Drop Down' || item.fieldTypeCode === 'Radio Button') {
            item.splittedQuesAndAnswData = item.fieldValues.split(',').map((value: any) => ({
              valueExp: value,
              displayExp: value,
            }));
            item.organizedQuesAndAnswData = [...item.organizedQuesAndAnswData, ...item.splittedQuesAndAnswData];
            if (item.fieldTypeCode == 'Drop Down' && item.response != null) {
              item.selectedFlexifieldValue = item.response;
            }
            if ((item.fieldTypeCode == 'Multiselect Drop Down') && item.response != null) {
              let array = item.response.split(",");
              item.selectedFlexifieldValue = [...new Set(array.filter((val: any) => val.trim() !== ''))];
            }
          }
          if (item.fieldTypeCode == 'Date Field') {
            item.fieldValues = item.fieldValues ? new Date(item.fieldValues) : null;
            //item.organizedQuesAndAnswData=[];
            //item.
          }

          if (item.status != null) {
            item.selectedReviewStatus = item.status;
            // item.selectedReviewStatus = [];
            // item.selectedReviewStatus.push({
            //   valueExp: item.status,
            //   displayExp: item.status,
            // })
            //item.organizedQuesAndAnswData=[];
            //item.
          }
          item.reviewStatusDropDown = this.dropDownForReviewStatus.map((value: any) => ({
            valueExp: value.codelistCode,
            displayExp: value.codelistName,
          }));
        });
        this.contentList = data;

        for (let i = 0; i < this.contentList.length; i++) {
          this.contentList[i].newSeq = i + 1;
        }
      } else {
        this.displayQuestionAndAnswerContainer = false;
      }

      this.isProcessing = false;
    })

    this.visibleReorderContentPopup = this.dialog.open(this.reorderContentPopup, this.reorderContentPopupConfig);
  }

  reorderContentFunction() {
    this.isProcessing = true;

    let l = 0;
    for (const obj of this.contentList) {
      delete obj.updatedOn;
      delete obj.createdOn;


      if (obj.selectedFlexifieldValue != undefined) {
        if (obj.fieldTypeCode == 'Drop Down') {
          obj.response = null;
          if (obj.selectedFlexifieldValue) {
            obj.response = obj.selectedFlexifieldValue
          }
        }
        else if (obj.fieldTypeCode == 'Multiselect Drop Down') {
          obj.response = "";
          if (obj.selectedFlexifieldValue.length > 0) {
            for (let p = 0; p < obj.selectedFlexifieldValue.length; p++) {
              obj.response += obj.selectedFlexifieldValue;
              obj.response += p == obj.selectedFlexifieldValue.length - 1 ? "" : ",";
            }
          }
        }
      }

      if (obj.selectedReviewStatus != undefined) {
        obj.status = null;
        if (obj.selectedReviewStatus) {
          obj.status = obj.selectedReviewStatus
        }
      }

      if (obj.fieldTypeCode == 'Date Field') {
        if (obj.fieldTypeCode) {
          obj.response = obj.fieldValues ? new Date(obj.fieldValues) : null;
        } else {
          obj.response = null
        }
      }

      obj.questionSeq = obj['newSeq'];

      this.appService.updateQmsAuQuestion(obj).subscribe((Response: any) => {
        l = l + 1;
        if (l == this.contentList.length - 1) {
          if (Response.resultType == "S") {
            this.showSnackBar(Response.result, Response.resultType);
            this.ngOnInit();
            this.visibleReorderContentPopup.close();
          } else {
            this.showSnackBar(Response.result, Response.resultType);
          }
          this.isProcessing = false;
        }
      });
    }
  }

  cancelReorderFunction() {
    this.visibleReorderContentPopup.close();
  }
  AuditeefieldVisible: boolean = false;
  AuditorfieldVisible: boolean = false;
  isDocumentUploaded: boolean;
  auditorComments: any;
  hideActionBtn: boolean;
  displayQuestionsFunction() {

    this.appService.getCodeListsByGroup('AU_REVIEW_STATUS').subscribe((data: any) => {
      this.dropDownForReviewStatus = data;
    })
    this.auNo = this.qualityService.activityId;
    if (this.auService.tabName == "Conduct Audit") {
      this.hideActionBtn = true;
    } else if (this.qualityService.activity.status == 'Pending Plan Approval') {
      this.hideActionBtn = true;
    } else if (this.qualityService.activity.status == 'Planned') {
      this.hideActionBtn = true;
    } else if (this.qualityService.activity.status == 'Initiated') {
      this.hideActionBtn = true;
    } else if (this.qualityService.activity.status == "Draft(Plan)" || this.qualityService.activity.status == "Plan Created"
      || this.qualityService.activity.status == "Plan Rejected" || this.qualityService.activity.status == "Re-Draft(Plan)") {
      this.hideActionBtn = false;
    } else {
      this.hideActionBtn = true;
    }
    this.auService.questionnaireList = [];
    if (this.auService.isAuditee && (this.qualityService.activity.status == 'Initiated' || this.qualityService.activity.status == 'In Progress/Q&A Pending')) {
      this.columnCount = 2;
      this.showAuditeeColumn = true;
      this.showAuditorColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = false;
    } else if ((this.auService.isAuditor || this.auService.isAuditee) && (this.qualityService.activity.status == 'Initiated/Received Q&A Response' || this.qualityService.activity.status == 'Received Q&A Response' || this.qualityService.activity.status == 'In Progress/Received Q&A Response')) {
      if (this.auService.isAuditor) {
        this.columnCount = 4;
        this.showAuditeeColumn = this.showAuditorColumn = this.freezeAuditeeColumn = true;
        this.freezeAuditorColumn = false;
      } else if (this.auService.isAuditee) {
        this.columnCount = 4;
        this.showAuditeeColumn = this.freezeAuditeeColumn = true;
        this.freezeAuditorColumn = true;
        this.showAuditorColumn = true;

      }
    } else if ((this.auService.isAuditor || this.auService.isAuditee) && (this.qualityService.activity.status == 'Initiated/Auditor Requested More Info. On Q&A Responses' || this.qualityService.activity.status == 'Auditor Requested More Info. On Q&A Responses' || this.qualityService.activity.status == 'In Progress/Auditor Requested More Info. On Q&A Responses')) {
      if (this.auService.isAuditor) {
        this.columnCount = 4;
        this.showAuditeeColumn = this.showAuditorColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = true;
      } else if (this.auService.isAuditee) {
        this.columnCount = 4;
        this.showAuditeeColumn = this.showAuditorColumn = true;
        this.freezeAuditeeColumn = false;
        this.freezeAuditorColumn = true;

      }
    } else if ((this.auService.isAuditor || this.auService.isAuditee) && (this.qualityService.activity.status == 'Pending Peer Review')) {
      if (this.auService.isAuditor) {
        this.columnCount = 4;
        this.showAuditeeColumn = this.showAuditorColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = true;
      } else if (this.auService.isAuditee) {
        this.columnCount = 0;
        this.showAuditorColumn = this.showAuditeeColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = true;
      }
    } else if (this.qualityService.activity.status.includes('In Progress') || this.qualityService.activity.status.includes('Closure Review') || this.qualityService.activity.status.includes('Closure Approve') || this.qualityService.activity.status.includes('Close')) {
      this.columnCount = 4;
      this.showAuditeeColumn = this.showAuditorColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = true;
    } else {
      this.columnCount = 0;
      this.showAuditorColumn = this.showAuditeeColumn = this.freezeAuditorColumn = this.freezeAuditeeColumn = false;
    }


    this.isProcessing = true;
    this.appService.getQmsAuQuestionsByAuNO(this.auNo).subscribe((data: any) => {
      if (data.length > 0) {
        this.displayQuestionAndAnswerContainer = true;
        data.forEach((item: any) => {
          item.splittedQuesAndAnswData = [];
          item.organizedQuesAndAnswData = [];
          item.reviewStatusDropDown = [];

          if (item.fieldTypeCode === 'Drop Down' || item.fieldTypeCode === 'Multiselect Drop Down' || item.fieldTypeCode === 'Radio Button') {

            item.splittedQuesAndAnswData = item.fieldValues?.split(',').map((value: any) => ({
              valueExp: value,
              displayExp: value,
            }));

            item.organizedQuesAndAnswData = [...item.organizedQuesAndAnswData, ...item.splittedQuesAndAnswData];
            if (item.fieldTypeCode == 'Drop Down' && item.response != null) {
              item.selectedFlexifieldValue = item.response;
            }
            if ((item.fieldTypeCode == 'Multiselect Drop Down') && item.response != null) {
              let array = item.response.split(",");
              item.selectedFlexifieldValue = [...new Set(array.filter((val: any) => val.trim() !== ''))];

              // Explicitly set the Select All state
              const totalOptions = item.fieldValues.split(',').length;
              item.isSelectAllChecked = item.selectedFlexifieldValue.length === totalOptions;
            }
          }

          if ((item.fieldTypeCode == "Check Box") && item.fieldValues != null) {
            let littkey = item.fieldValues ? item.fieldValues.split(',') : [];
            let fieldValuesdata = item.response ? item.response.split(",") : [];
            let dropdownlist = [];
            let obj1: any = {};
            for (let j = 0; j < littkey.length; j++) {
              if (littkey.includes(fieldValuesdata[j])) {
                dropdownlist.push({ name: littkey[j], checked: true });
              } else {
                dropdownlist.push({ name: littkey[j], checked: false });
              }
            }
            item.fieldValuesList = dropdownlist;
          }
          if (item.fieldTypeCode == 'Date Field') {
            if (item.response) {
              item.fieldValues = new Date(item.response);
            } else {
              item.fieldValues = null;
            }
          }

          if (item.status != null) {
            item.selectedReviewStatus = item.status;
          }
          item.reviewStatusDropDown = this.dropDownForReviewStatus.map((value: any) => ({
            valueExp: value.codelistCode,
            displayExp: value.codelistName,
          }));
        });

        this.reviewStatusDropDownBulkStatus = this.dropDownForReviewStatus.map((value: any) => ({
          valueExp: value.codelistCode,
          displayExp: value.codelistName,
        }));

        this.qualityService.auQuestionarie = data;
        this.auService.questionnaireList = data;
        let p = 0;
        for (const element of this.auService.questionnaireList) {
          this.appService.getQmsTaskDocumentsVwDetailsByauRefId(this.qualityService.activityId, element.questionId).subscribe((response: any) => {

            if (response.length > 0) {
              for (const element of this.auService.questionnaireList) {
                if (element.questionId == response[0].auditRefId) {
                  element.docs = response;
                }
              }
            }
            p++;
          });
        }
        this.getUploadColors();

      } else {
        this.displayQuestionAndAnswerContainer = false;
      }

      this.isProcessing = false;
    })
  }

  saveButton1() {
    let l = 0;
    if (this.selectedCommonReviewStatus != null && (this.auditorComments != null && this.auditorComments != "")) {
      this.showBulkStatus = false;
      for (const element of this.auService.questionnaireList) {
        if (element.childCheckBoxs) {
          element.childCheckBoxs = false;
          let obj = element;
          delete obj.updatedOn;
          delete obj.createdOn;
          obj.selectedReviewStatus = this.selectedCommonReviewStatus;
          obj.auditorComments = this.auditorComments;


          if (obj.selectedFlexifieldValue != undefined) {
            if (obj.fieldTypeCode == 'Drop Down') {
              obj.response = null;
              if (obj.selectedFlexifieldValue) {
                obj.response = obj.selectedFlexifieldValue
              }
            }
            else if (obj.fieldTypeCode == 'Multiselect Drop Down') {
              obj.response = "";
              if (obj.selectedFlexifieldValue && obj.selectedFlexifieldValue.length > 0) {
                obj.response = obj.selectedFlexifieldValue.join(",");
              }
            }
          }
          if (obj.selectedReviewStatus) {
            obj.status = null;
            if (obj.selectedReviewStatus) {
              obj.status = obj.selectedReviewStatus
            }
          }
          if (obj.fieldTypeCode == 'Date Field') {
            if (obj.fieldTypeCode) {
              obj.response = new Date(obj.fieldValues);
            } else {
              obj.response = null
            }

          }
          if ((obj.fieldTypeCode == "Check Box")) {
            let checkedValues = [];
            for (let checkedObj of obj.fieldValuesList) {
              if (checkedObj.checked) {
                checkedValues.push(checkedObj.name);
              }
            }
            obj.response = checkedValues.join(",");
          }
          this.appService.updateQmsAuQuestion(obj).subscribe((Response: any) => {

            if (Response.resultType == "S") {
              this.showSnackBar(Response.result, Response.resultType);
              this.displayQuestionsFunction();
              this.cancelVendorPopup();
            } else {
              this.showSnackBar(Response.result, Response.resultType);
            }
            this.isProcessing = false;
          }
          );
        }
      }
    } else {
      alert("Please enter the mandatory fields");
    }
  }

  responseMandatoryValidation: boolean;
  saveButton() {
    this.responseMandatoryValidation = false;
    for (const element of this.auService.questionnaireList) {
      let obj = element;
      delete obj.updatedOn;
      delete obj.createdOn;


      if (obj.selectedFlexifieldValue != undefined) {
        if (obj.fieldTypeCode == 'Drop Down') {
          obj.response = null;
          if (obj.selectedFlexifieldValue) {
            obj.response = obj.selectedFlexifieldValue
          }
        }
        else if (obj.fieldTypeCode == 'Multiselect Drop Down') {
          obj.response = "";
          if (obj.selectedFlexifieldValue.length > 0) {
            for (let q = 0; q < obj.selectedFlexifieldValue.length; q++) {
              obj.response += obj.selectedFlexifieldValue;
              obj.response += q == obj.selectedFlexifieldValue.length - 1 ? "" : ",";
            }
          }
        }
      }
      if (obj.selectedReviewStatus) {
        obj.status = null;
        if (obj.selectedReviewStatus) {
          obj.status = obj.selectedReviewStatus
        }
      }
      if (obj.fieldTypeCode == 'Date Field') {
        if (obj.fieldTypeCode) {
          obj.response = new Date(obj.fieldValues);
        } else {
          obj.response = null
        }

      }
      if ((obj.fieldTypeCode == "Check Box")) {
        let checkedValues = [];
        for (let checkedObj of obj.fieldValuesList) {
          if (checkedObj.checked) {
            checkedValues.push(checkedObj.name);
          }
        }
        obj.response = checkedValues.join(",");

      }
      if (obj.fieldTypeCode == "Text Field" || obj.fieldTypeCode == "Large Text Field") {
        obj.response = obj.fieldValues;
      }
      if (this.auService.isAuditee) {
        if (((obj.response == null || obj.response == "") && obj.fieldTypeCode != "Heading")) {
          this.responseMandatoryValidation = true;
        };
      } else if (this.auService.isAuditor && this.auService.tabName == 'Conduct Audit') {
        if ((!obj.selectedReviewStatus || obj.selectedReviewStatus == "Pending") || (!obj.auditorComments)) {
          this.responseMandatoryValidation = true;
        }
      }

      ;
    }

    if (this.responseMandatoryValidation) {
      alert("Please review the Questionnaire !")
    } else {
      let dropDownCounter = 0;
      if (this.qualityService.activity.status == "Initiated/Received Q&A Response") {
        for (const element of this.auService.questionnaireList) {
          if (!element.selectedReviewStatus) {
            dropDownCounter++;
          }
        }
      }

      let l = 0;
      for (const element of this.auService.questionnaireList) {
        let obj = element;
        delete obj.updatedOn;
        delete obj.createdOn;


        if (obj.selectedFlexifieldValue) {
          if (obj.fieldTypeCode == 'Drop Down') {
            obj.response = null;
            if (obj.selectedFlexifieldValue) {
              obj.response = obj.selectedFlexifieldValue
            }
          }
          else if (obj.fieldTypeCode == 'Multiselect Drop Down') {
            obj.response = "";
            if (obj.selectedFlexifieldValue.length > 0) {
              for (let p = 0; p < obj.selectedFlexifieldValue.length; p++) {
                obj.response += obj.selectedFlexifieldValue;
                obj.response += p == obj.selectedFlexifieldValue.length - 1 ? "" : ",";
              }
            }
          }
        }

        obj.status = obj.selectedReviewStatus

        if (obj.fieldTypeCode == 'Date Field') {
          if (obj.fieldTypeCode) {
            obj.response = new Date(obj.fieldValues);
          } else {
            obj.response = null
          }

        }
        if ((obj.fieldTypeCode == "Check Box")) {
          let checkedValues = [];
          for (let checkedObj of obj.fieldValuesList) {
            if (checkedObj.checked) {
              checkedValues.push(checkedObj.name);
            }
          }
          obj.response = checkedValues.join(",");
        }
        this.appService.updateQmsAuQuestion(obj).subscribe((Response: any) => {
          l = l + 1;
          if (l == this.auService.questionnaireList.length - 1 || this.auService.questionnaireList.length == 1) {
            if (Response.resultType == "S") {
              if (this.qualityService.isUpdatingAUThroughDynBtn) {
                this.qualityService.isUpdatingAUThroughDynBtn = false;
              } else {
                this.showSnackBar(Response.result, Response.resultType);
                this.displayQuestionsFunction();
                this.cancelVendorPopup();
              }
            } else {
              this.showSnackBar(Response.result, Response.resultType);
            }
            this.isProcessing = false;
          }
        }
        );
      }
    }
  }

  editQuestion(quesAndAnsw: any): any {
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Edit Question";
    this.auQuestionsData = quesAndAnsw;
    this.auQuestionsData.addQuestionType = 'manually';
    this.selectedFieldType = quesAndAnsw.fieldTypeCode;
    this.markFieldValuesAsMandatory = ['Multiselect Drop Down', 'Drop Down', 'Radio Button', 'Check Box'].includes(quesAndAnsw.fieldTypeCode);
    this.visibleAddPopup = this.dialog.open(this.addPopup, this.addPopupConfig);
  }

  deleteReason: any;
  obj: any;
  deleteQuestion(quesAndAnsw: any) {
    this.obj = quesAndAnsw;
    this.deleteReason = null
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
    this.isProcessing = false;

  }
  deleteFiledValue: any;
  deleteFunction(qmsBusinesssAreaFieldData: any) {

    delete this.obj.updatedOn;
    delete this.obj.createdOn;

    if (this.obj.selectedFlexifieldValue != undefined) {
      if (this.obj.fieldTypeCode == 'Drop Down') {
        this.obj.response = null;
        if (this.obj.selectedFlexifieldValue) {
          this.obj.response = this.obj.selectedFlexifieldValue
        }
      }
      else if (this.obj.fieldTypeCode == 'Multiselect Drop Down') {
        this.obj.response = "";
        if (this.obj.selectedFlexifieldValue.length > 0) {
          for (let p = 0; p < this.obj.selectedFlexifieldValue.length; p++) {
            this.obj.response += this.obj.selectedFlexifieldValue;
            this.obj.response += p == this.obj.selectedFlexifieldValue.length - 1 ? "" : ",";
          }
        }
      }
    }
    if (this.obj.selectedReviewStatus != undefined) {
      this.obj.status = null;
      if (this.obj.selectedReviewStatus) {
        this.obj.status = this.obj.selectedReviewStatus
      }
    }

    this.obj.deleteReason = this.deleteReason;
    this.appService.deleteQmsAuQuestion(this.obj).subscribe((Response: any) => {
      if (Response.resultType == "S") {
        this.visibleDeletePopup.close();
        this.showSnackBar(Response.result, Response.resultType);
        this.displayQuestionsFunction();
      } else {
        this.showSnackBar(Response.result, Response.resultType);
      }
      this.isProcessing = false;
    }
    );
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }
  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.thirdLevel : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  ccpDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  pager: any = {};
  pagedItems: any[];
  error = '';
  questionTemplate: any = [];

  getCall() {
    this.questionTemplate = [];
    const data = {

      gridName: "QUESTIONNAIRE_TEMPLATE"
    }

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;
        const data1: any = {

          gridName: "QMS_QUESTIONNAIRE_TEMPLATES_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          templateType: this.qualityService.selectedAuditType,
          module: 'AU'
        }

        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            for (const element of response1) {
              if (element.IS_ACTIVE == 'Y') {
                this.questionTemplate.push(element);
              }
            }

            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const element of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(element + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (const element of this.columnLists.invisibleColumnarray) {
                if (this.columnLists.columnsListarray[y] == element) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe({
              next: (response2: any) => {
                this.dataTypeList = response2;
                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({});
                  this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                  this.columnLists.columnsListarray1[m].dataType = "textbox";
                  this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                  for (const element of this.dataTypeList) {
                    if (element.columnName == this.columnLists.columnsListarray[m]) {
                      this.columnLists.columnsListarray1[m].dataType = element.fieldType;
                    }
                  }
                }
                for (const row of this.questionTemplate) {
                  for (const element of this.dataTypeList) {
                    if (element.fieldType == 'CHECKBOX') {
                      row[element.columnName] = row[element.columnName] == "Y";
                    }
                  }
                }
                this.calculateTotalPages = this.collectionSize / this.perPage;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              },
              error: (error) => {
                this.isProcessing = false;
                throw error;
              }
            });
            this.message.gridList = this.questionTemplate;
            this.collectionSize = this.questionTemplate.length;
            this.totalPages = Math.ceil(this.questionTemplate.length / this.itemsPerPage);
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      },
      error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.questionTemplate.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.questionTemplate.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  detailsData(list: any, idx: any) {
    this.auService.questionTemplateId = list.TEMPLATE_ID;
    this.visibleSelectQuestionPopup = this.dialog.open(this.selectQuestionPopup, this.selectQuestionPopupConfig);
  }
  vendorPopupConfig = {
    width: '36%',
    height: '45%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };
  @ViewChild('vendorPopup', { static: true }) vendorPopup: TemplateRef<any>;
  visibleVendorPopup: MatDialogRef<TemplateRef<any>>;
  selectedCommonReviewStatus: any = null;
  openPopup() {
    this.selectedCommonReviewStatus = null;
    this.auditorComments = "";
    this.visibleVendorPopup = this.dialog.open(this.vendorPopup, this.vendorPopupConfig);
  }
  cancelVendorPopup() {
    this.visibleVendorPopup.close();
  }
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  showBulkStatus: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      this.showBulkStatus = true;
      for (const element of this.questionTemplate) {
        element.childCheckBoxs = true;
      }
      for (const element of this.auService.questionnaireList) {
        element.childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      this.showBulkStatus = false;
      let p;
      for (p = 0; p < this.questionTemplate.length; p++) {
        this.questionTemplate[p].childCheckBoxs = false;
      }
      this.auService.questionnaireList[p].childCheckBoxs = false;
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    this.showBulkStatus = false;
    if (e.target.checked) {
      list.childCheckBoxs = true;
      this.showBulkStatus = true;
    } else {
      list.childCheckBoxs = false;
      for (const element of this.auService.questionnaireList) {
        if (element.childCheckBoxs) {
          this.showBulkStatus = true;
        };
      }
    }

  }

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.questionTemplate.length, page, this.perPage, targetpage);
    this.pagedItems = this.questionTemplate
      .slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  objForDocuments: any;
  documentIdx: any;
  uploadBtn(list: any, idx: any) {
    this.auService.questionnaireId = list.questionId;
    this.objForDocuments = {
      id: list.questionId,
      pagename: "Audit Questionnaire"
    };
    this.documentIdx = idx;
    this.visibleUploadDocumentsPopup = this.dialog.open(this.uploadDocuments, this.uploadPopupConfig);
  }

  cancelUploadBtnFunction() {
    this.visibleUploadDocumentsPopup.close();
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;
  openAuditTrail(viewType: any, question: any) {
    this.message.tableOrView_Name = "QMS_AU_QUESTIONS_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,QUESTION_SEQ,QUESTION,FIELD_TYPE_CODE,FIELD_VALUES,RESPONSE,STATUS,AUDITEE_COMMENTS,AUDITOR_COMMENTS,CREATED_ON,UPDATED_ON,CREATED_BY_USER,UPDATED_BY_USER,DELETED_BY_USER,DELETED_REASON";
    this.message.columnList_UI = "Created Ts,End Ts,Action Flag,Question Seq,Question,Field Type Code,Field Values,Response,Status,Auditee Comments,Auditor Comments,Created On,Updated On,Created By User,Updated By User,Deleted By User,Deleted Reason";
    this.message.whereClause_AU = viewType == 'overAll' ? " AND AU_NO = " + this.message.activityId : " AND AU_NO = " + this.message.activityId + " AND QUESTION_ID = " + question.questionId;
    this.message.columnList_Report = "Created Ts,End Ts,Action Flag,Question Seq,Question,Field Type Code,Field Values,Response,Status,Auditee Comments,Auditor Comments,Created On,Updated On,Created By User,Updated By User,Deleted By User,Deleted Reason";
    this.message.whereClause_Report = viewType == 'overAll' ? " WHERE AU_NO = " + this.message.activityId : " WHERE AU_NO = " + this.message.activityId + " AND QUESTION_ID = " + question.questionId;
    this.message.report_And_Popup_Name = "Audit Questions Audit Trail";
    this.staticAuditTrailComponent.triggerTrail(question);
  }

  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }

  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;

  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;

  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }

  reportObj: any = {};
  htmlContent: any;

  @ViewChild(EditorComponent) editorComponent!: EditorComponent;

  getClobData(data: any, column: string, val: any, view: string) {
    this.isProcessing = true;
    const formattedColumn = this.formatColumnName(column);
    this.htmlContent = val;
    this.editorComponent.openEditor(this.htmlContent, formattedColumn);
    this.isProcessing = false;
  }

  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  isSaveReport: boolean = false;
  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;

  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }

  reportName: any;
  @ViewChild('pdfColumnVal') pdfColumnVal: MatSelect;
  pdfColumnSelection = false;
  generateReport(value: any) {

    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else if (value == 'Pdf' && this.manuallyPicked && this.selectedColumns.length > 12) {
      alert('Selected columns exceeded the limit. Limit 12, Selected ' + this.selectedColumns.length);
    } else {
      this.appService.isProcessingRep = true;
      let tname = "";
      let colList = "";
      let fieldList = "";
      let invisibleList = "";

      tname = "QMS_AU_QUESTIONS_VW";
      colList = "QUESTION_SEQ,QUESTION,RESPONSE,AUDITEE_COMMENTS,STATUS,AUDITOR_COMMENTS";
      fieldList = "Seq.,Question,Response,Auditee Comments,Review Status,Auditor Comments";

      const data = {

        groupId: this.qualityService.selectedGroup
      }
      const data1: any = {

        tableOrViewName: tname,
        columnsList: colList,
        fieldLabelsList: fieldList,
        invisibleColumn: invisibleList,
        orderByClause: "QUESTION_SEQ",
        fieldSizeList: "",
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        status: null,
        codelistGroup: null,
        manualEntryDataFields: null,
        groupId: this.qualityService.selectedActivityGroupId,
        chartStatus: null,
        reModule: "qms",
        footer: null,
        logoId: 0,
        isSaveRep: this.isSaveReport ? 'Y' : 'N',
        reportName: this.reportName ?? "Report",
        currentStatus: "NA",
        module: this.qualityService.moduleName,
        wherVal: " WHERE AU_NO=" + this.qualityService.activityId,
        groupName: this.qualityService.activity.groupName + "",
      }

      this.reportObj = { ...data1, ...data };
      const timestamp = Date.now();
      const formattedDate = new Intl.DateTimeFormat('en-US', {
        day: '2-digit', month: 'short', year: 'numeric',
      }).format(new Date(timestamp)).replaceAll(/[, ]/g, (match) => match === ',' ? '' : '_');

      let fileName = this.reportName;

      if (value == 'Excel') {
        const pdfData = {
          ...this.reportObj, title: "Report", columns: [],
          "informationTab": {
            "Report Name": this.reportName,
            "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
          }
        }
        this.appService.downloadexcelForChart(pdfData, fileName + `_${formattedDate}` + ".xlsx");
      } else {
        const pdfData = {
          ...this.reportObj, title: this.reportName, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
        }
        this.appService.downloadPdfForChart(pdfData, fileName + `_${formattedDate}` + ".pdf");
      }
    }
  }

  openReport(item: any) {
    this.columnList = "Seq.,Question,Response,Auditee Comments,Review Status,Auditor Comments";
    this.excelPdf.dropDown = this.columnList.split(',').map((column: any) => ({ valueExp: column, displayExp: column }));
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];

    this.reportName = this.qualityService.moduleName + '-Questionnaire Report [' + this.qualityService.activity.auId + ']';
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.pdfColumnSelection = false;
    this.isSaveReport = false;
  }

  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
  }

  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;
  @ViewChild('pdf') pdf: MatSelect;

  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) {
          this.maxCountReached = true;
        } else {
          this.maxCountReached = false;
        }
        this.convertArrayToString(this.selectedColumns);
        this.pdfColumnSelection = this.selectedColumns.length === this.excelPdf.dropDown.length;
      });
    }

  }

  onPDFSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.pdfColumnSelection = this.excelPdf.dropDown.length == this.selectedColumns.length;
        this.convertArrayToString(this.selectedColumns);
      })
    }
  }
  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const element of this.organizationReportImageDetails) {

              if (element.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: element.reportImageId,
                  displayExp: element.reportImageName
                });
              }

            }
          }
        }
      } else {
        for (const element of this.organizationReportImageDetails) {
          if (element.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: element.reportImageId,
              displayExp: element.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const element of this.reportLogoDropdown) {
          if (element.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = element.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;
        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
        }

        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qualityService.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }
  //end excell & pdf

  isAllOptionsSelected(questionItem: any): boolean {
    if (!questionItem?.fieldValues || !questionItem?.selectedFlexifieldValue?.length) {
      return false;
    }

    const totalOptions = questionItem.fieldValues.split(',').length; // "TEST,TESTIEE,TESTERS,TESTDOC" = 4
    const selectedOptions = questionItem.selectedFlexifieldValue.length; // ["TEST", "TESTDOC", "TESTERS", "TESTIEE"] = 4

    return selectedOptions === totalOptions;
  }

  resultGrid: any = [];
  public on_response_emit(event: { responses: any }): void {
    this.resultGrid = event;
    this.visibleResultPopup = this.dialog.open(this.resultPopup, this.resultPopupConfig);
  }

  @ViewChild('resultPopup', { static: true }) resultPopup: TemplateRef<any>;
  visibleResultPopup: MatDialogRef<TemplateRef<any>>;

  resultPopupConfig = {
    width: '32%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  cancelResultPopup() {
    this.visibleResultPopup.close();
  }

  public focusEmpty(): void {
    console.log();
  }
}
